import AbstractView from './AbstractView';

class Account extends AbstractView {
  constructor() {
    super(...arguments);
  }

  bind() {
    super.bind();
    this.handleClickOrderLink = this.handleClickOrderLink.bind(this);
    this.handleDelete = this.handleDelete.bind(this);
  }

  enter() {}

  getUI() {
    const ui = super.getUI();
    ui.$addressCountryOptions = [...ui.$element.querySelectorAll('.address-country-option')];
    return ui;
  }

  initialize() {
    super.initialize();

    // Initialize observers on address selectors, defined in shopify_common.js
    if (Shopify) {
      this.ui.$addressCountryOptions.forEach(($element) => {
        const { formId } = $element.dataset;
        const countrySelector = 'AddressCountry_' + formId;
        const provinceSelector = 'AddressProvince_' + formId;
        const containerSelector = 'AddressProvinceContainer_' + formId;

        new Shopify.CountryProvinceSelector(countrySelector, provinceSelector, {
          hideElement: containerSelector,
        });
      });
    }
  }

  events(listen) {
    const listener = listen ? 'on' : 'off';
    $(document.body)[listener]('click', '.address-delete', this.handleDelete);
    $(document.body)[listener]('click', '.customer__order__link', this.handleClickOrderLink);
  }

  handleClickOrderLink(event) {
    event.preventDefault();
    const { href } = event.target;
    $.ajax({
      url: href,
      xhrFields: {
        withCredentials: true,
      },
    }).then((html) => {
      const $dom = $(html);
      const modal = this.modals.find((modal) => modal.id === 'modal-order');
      modal.ui.$content.innerHTML = $dom.find('.order')[0].outerHTML;
      modal.open();
    });
  }

  handleDelete(event) {
    const $el = $(event.currentTarget);
    const target = $el.data('target');
    const confirmMessage = $el.data('confirm-message');

    const confirmed = confirm(confirmMessage || 'Are you sure you wish to delete this address?');
    // eslint-disable-next-line no-alert
    if (confirmed) {
      Shopify.postLink(target, {
        parameters: { _method: 'delete' },
      });
    }
  }
}

export default Account;
